export const DISCREPANCY_SOURCES = [
    { label: 'Purchases', value: 'purchase' },
    { label: 'Sales', value: 'sales' },
]